import UserTotalPSPs from './UserTotalPSPs';

export default UserTotalPSPs;
